// const BASE_URL = "http://localhost:5001";
export const BASE_URL = "https://www.ericchang.homes";
